import { call, put, takeLatest } from "redux-saga/effects";
import { message } from "antd";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import api from "service/apiService";
import { GetDetailAffiliatePaymentPayload, GetListAffiliatePaymentPayload, UpdateAffiliatePaymentPayload, UpdateStatusAffiliatePaymentPayload, getDetailAffiliatePaymentAsync, getListAffiliatePaymentAsync, setDetailAffiliatePayment, setListAffiliatePayment, updateAffiliatePaymentAsync, updateStatusAffiliatePaymentAsync } from "./payment.slice";

function* getListAffiliatePaymentSaga(
	action: PayloadAction<GetListAffiliatePaymentPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/affiliates/payments", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListAffiliatePayment.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListAffiliatePayment() {
	yield takeLatest(getListAffiliatePaymentAsync, getListAffiliatePaymentSaga);
}

function* getDetailAffiliatePaymentSaga(
	action: PayloadAction<GetDetailAffiliatePaymentPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/affiliates/payments/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		yield put({ type: setDetailAffiliatePayment.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailAffiliatePayment() {
	yield takeLatest(getDetailAffiliatePaymentAsync, getDetailAffiliatePaymentSaga);
}

function* updateAffiliatePaymentSaga(
	action: PayloadAction<UpdateAffiliatePaymentPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(
				`/dashboard/affiliates/payments/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateAffiliatePayment() {
	yield takeLatest(updateAffiliatePaymentAsync, updateAffiliatePaymentSaga);
}

function* updateStatusAffiliatePaymentSaga(
	action: PayloadAction<UpdateStatusAffiliatePaymentPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post(
				`/dashboard/affiliates/payments/${id}/paid`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateStatusAffiliatePayment() {
	yield takeLatest(updateStatusAffiliatePaymentAsync, updateStatusAffiliatePaymentSaga);
}

const affiliatePaymentSaga = [
	watchGetListAffiliatePayment(),
	watchUpdateAffiliatePayment(),
	watchGetDetailAffiliatePayment(),
	watchUpdateStatusAffiliatePayment(),
];

export default affiliatePaymentSaga;